/**
 * userChipsDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */
import { UserPresenter } from '../user-presenter';

userChipsDirective.$inject = ['$userFetcher', '$errorHandler'];

function userChipsDirective($userFetcher, $errorHandler) {
    return {
        // language=HTML
        template: `
            <md-chips name="{{ name }}"
                      ng-model="selectedUsers"
                      md-require-match="true"
                      md-autocomplete-snap
                      md-on-add="onChange($event)"
                      md-on-remove="onChange($event)"
                      readonly="hasReachedMax() || readOnly">

                <md-autocomplete
                        md-item-text="itemName(item)"
                        md-items="item in querySearch(searchText)"
                        md-menu-class="md-contact-chips-suggestions"
                        md-no-cache="true"
                        md-search-text="searchText"
                        md-selected-item="selectedItem"
                        md-min-length="0"
                        ng-hide="hasReachedMax()"
                        placeholder="{{ hasReachedMax() ? '' : (selectedUsers.length == 0 ? 'Start typing a name' : 'Start typing another name') }}">

                    <div class="md-contact-suggestion">
                        <img
                                ng-src="{{ item.$presenter.person.avatar }}"
                                alt="{{ item.$presenter.name }}"
                                ng-if="item.$presenter.person.avatar"/>

                        <span class="md-contact-name" md-highlight-text="searchText" md-highlight-flags="ig">
                            {{ item.$presenter.name }}
                        </span>
                    </div>

                </md-autocomplete>

                <md-chip-template ng-click="onUserClick({$event: $event, user: $chip})">
                    <div class="user__avatar">
                        <img
                                ng-src="{{ $chip.$presenter.person.avatar }}"
                                ng-if="$chip.$presenter.person.avatar"
                                alt="{{ $chip.$presenter.name }}"/>
                    </div>

                    <div class="user__name">
                        {{ $chip.$presenter.name }}
                    </div>
                </md-chip-template>
            </md-chips>

            <small class="hint" ng-if="hint">
                {{ hint }}
            </small>
        `,
        scope: {
            fetcherParams: '=?fetcherParams',
            maxUsers: '=?maxUsers',
            name: '=?name',
            hint: '@hint',
            onUserClick: '&?onUserClick',
            readOnly: '=?readOnly',
            single: '=?single',
            users: '=users',
        },
        link: function(scope) {
            let hasInputStarted = false;

            scope.allUsers = [];
            scope.selectedUsers = [];

            scope.hasReachedMax = hasReachedMax;
            scope.onChange = onChange;
            scope.querySearch = querySearch;

            scope.fetcherParams = angular.isDefined(scope.fetcherParams) ? scope.fetcherParams : {};
            scope.maxUsers = scope.single ? 1 : angular.isDefined(scope.maxUsers) ? scope.maxUsers : 1;
            scope.single = angular.isDefined(scope.single) ? scope.single : false;

            scope.$watch('users', users => {
                if (hasInputStarted) {
                    return;
                }

                if (users) {
                    if (Array.isArray(users)) {
                        if (users.length > 0) {
                            scope.selectedUsers = scope.single ? [users[0]] : users;
                        }
                    } else if (angular.isObject(users)) {
                        scope.selectedUsers = [users];
                    }
                } else {
                    scope.selectedUsers = [];
                }

                scope.selectedUsers.forEach(user => {
                    if (!user.$presenter) {
                        user.$presenter = new UserPresenter(user);
                    }
                });
            });

            scope.$watchCollection('selectedUsers', function(newValue) {
                if (!hasInputStarted) {
                    return;
                }

                if (scope.single) {
                    scope.users = newValue.length > 0 ? newValue[0] : null;
                } else {
                    scope.users = newValue;
                }
            });

            fetchUsers();

            function hasReachedMax() {
                return scope.selectedUsers.length >= scope.maxUsers;
            }

            function fetchUsers() {
                const fetcherParams = {
                    fields: 'id',
                    include: ['person:fields(first_name|last_name)'],
                };

                $userFetcher
                    .all(Object.assign({}, fetcherParams, scope.fetcherParams))
                    .then(data => {
                        scope.allUsers = data.data;

                        scope.allUsers.map(user => {
                            user.$presenter = new UserPresenter(user);

                            // Cache lower cache names
                            user.$$lowerFirstName = user.$presenter.firstName.toLowerCase();
                            user.$$lowerLastName = user.$presenter.lastName.toLowerCase();
                            user.$$lowerName = user.$presenter.name.toLowerCase();
                        });
                    })
                    .catch(error => {
                        $errorHandler.handle(error);
                    });
            }

            function onChange() {
                hasInputStarted = true;
            }

            function querySearch($query) {
                if (!$query) {
                    return scope.allUsers;
                }

                const queryParts = $query.toLowerCase().split(' ');

                return scope.allUsers.filter(user => {
                    for (const queryPart of queryParts) {
                        if (user.$$lowerFirstName.indexOf(queryPart) !== -1) {
                            return true;
                        }

                        if (user.$$lowerLastName.indexOf(queryPart) !== -1) {
                            return true;
                        }

                        if (user.$$lowerName.indexOf(queryPart) !== -1) {
                            return true;
                        }
                    }
                });
            }
        },
    };
}

export default userChipsDirective;
